export const ROUTE_PATHS = {
  HOME: '/',
  ABOUT: '#about',
  SERVICES: '#services',
  PORTFOLIO: '#portfolio',
  PROCESS: '#process',
  REVIEWS: '#reviews',
  PRICING: '#pricing',
  FAQ: '#faq',
  BLOG: '#blog',
  CONTACT: '#contact',
} as const;

export const COMPANY_INFO = {
  NAME: 'VANCORE BUILDING SOLUTIONS INC.',
  ADDRESS: '6378 Silver Ave, Burnaby BC V5H 4K3, Canada',
  PHONE: '672-755-8341',
  EMAIL: 'info@vancorebuild.ca',
  FOUNDED: 2016,
  HEADQUARTERS: 'Burnaby, BC',
  SERVICE_AREAS: [
    'Vancouver',
    'Toronto',
    'Calgary',
    'Montreal',
    'Ottawa',
    'Edmonton',
    'Winnipeg',
  ],
} as const;

export type Language = 'EN' | 'ZH' | 'FR';

export interface Service {
  id: string;
  icon: string;
  name: string;
  description: string;
  startingPrice: number;
  features: string[];
  howWeWork: string;
  warranty: string;
  image: string;
}

export interface Project {
  id: string;
  title: string;
  location: string;
  province: string;
  budget: {
    min: number;
    max: number;
  };
  duration: string;
  category: 'flooring' | 'cabinets' | 'interior' | 'renovation';
  style: string;
  coverImage: string;
  images: string[];
  scopeOfWork: string[];
  challenge: string;
  solution: string;
}

export interface Review {
  id: string;
  name: string;
  location: string;
  province: string;
  rating: 5;
  text: string;
  date: string;
}

export interface BlogPost {
  id: string;
  title: string;
  category: string;
  excerpt: string;
  thumbnail: string;
  author: string;
  date: string;
  readTime: string;
  content: string;
}

export interface PricingTier {
  id: string;
  name: string;
  priceRange: {
    min: number;
    max: number;
  };
  features: string[];
  highlighted?: boolean;
}

export interface FAQItem {
  id: string;
  question: string;
  answer: string;
}

export interface ProcessStep {
  id: string;
  number: number;
  title: string;
  description: string;
  icon: string;
}
